import { InternalAccessor, Table, TableCellContent, TableColumn } from '@billy/design-system'
import React, { useCallback, useMemo } from 'react'
import { Row } from 'react-table'

import { SubscriptionInvoice } from '../../types/subscriptionInvoice'
import { DateFormatter } from '../TableCellFormatters'
import { Translate } from '../Translate'
import * as Styled from './styles'
import { InvoicesTableRow } from './types/invoicesTableRow'

interface SubscriptionInvoicesListProps {
  invoices?: SubscriptionInvoice[]
  isLoading?: boolean
}

export const SubscriptionInvoicesList = ({ invoices, isLoading }: SubscriptionInvoicesListProps) => {
  const handleRowClick = useCallback((row: Row<InvoicesTableRow>) => {
    const { downloadUrl, printUrl } = row.original

    if (downloadUrl) {
      window.open(downloadUrl, '_blank')
      return
    }
    if (printUrl) {
      window.open(printUrl, '_blank')
    }
  }, [])

  const columns: TableColumn<InvoicesTableRow>[] = useMemo(
    () => [
      {
        accessor: 'createdTime',
        Cell: ({ value }) => (
          <TableCellContent>
            <DateFormatter value={value} />
          </TableCellContent>
        ),
        Header: <Translate value="date" />,
        size: 'xxs',
      },
      {
        accessor: 'invoiceNo',
        Header: <Translate value="invoice.no" />,
        size: 'xxs',
      },
      {
        accessor: 'state',
        Header: <Translate value="subscription_invoices.state" />,
        size: 'xxs',
      },
      {
        accessor: 'total',
        Header: <Translate value="total" />,
        size: 'xxs',
      },
    ],
    [],
  )

  const tableData = useMemo(() => {
    if (isLoading || !invoices) {
      return []
    }

    return invoices.map((invoice) => ({
      ...invoice,
      total: invoice.amount + invoice.tax,
      [InternalAccessor.HoverActions]: true,
    }))
  }, [invoices, isLoading])

  return (
    <Styled.SubscriptionInvoicesListWrapper>
      <Table
        columns={columns}
        data={tableData}
        isLoading={isLoading}
        skeletonItemsPerPage={3}
        onRowClick={handleRowClick}
        bordered
      />
    </Styled.SubscriptionInvoicesListWrapper>
  )
}
